// components/Footer.js
import React from 'react';

const Footer = () => {
  return (
    <>
      <p className="footer-text">
        By clicking "Complete Booking" you agree to the <a style={{ color: '#ff5733' }}  href='https://opticalsuperstore.com.au/terms-and-conditions/' target='_blank' rel="noreferrer noopener">terms and conditions</a> of the website.
        &nbsp;Read our <a style={{ color: '#ff5733' }} href='https://opticalsuperstore.com.au/privacy-policy/' target='_blank' rel="noreferrer noopener">Privacy Policy</a>
      </p>
    </>
  );
};

export default Footer;
